var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#004AC6",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9987 28.75C14.5404 28.75 14.148 28.5868 13.8216 28.2604C13.4952 27.934 13.332 27.5417 13.332 27.0833V18.75C13.332 18.2917 13.4952 17.8993 13.8216 17.5729C14.148 17.2465 14.5404 17.0833 14.9987 17.0833H15.832V15.4167C15.832 14.2639 16.2383 13.2812 17.0508 12.4688C17.8633 11.6562 18.8459 11.25 19.9987 11.25C21.1515 11.25 22.1341 11.6562 22.9466 12.4688C23.7591 13.2812 24.1654 14.2639 24.1654 15.4167V17.0833H24.9987C25.457 17.0833 25.8494 17.2465 26.1758 17.5729C26.5022 17.8993 26.6654 18.2917 26.6654 18.75V27.0833C26.6654 27.5417 26.5022 27.934 26.1758 28.2604C25.8494 28.5868 25.457 28.75 24.9987 28.75H14.9987ZM14.9987 27.0833H24.9987V18.75H14.9987V27.0833ZM19.9987 24.5833C20.457 24.5833 20.8494 24.4201 21.1758 24.0938C21.5022 23.7674 21.6654 23.375 21.6654 22.9167C21.6654 22.4583 21.5022 22.066 21.1758 21.7396C20.8494 21.4132 20.457 21.25 19.9987 21.25C19.5404 21.25 19.148 21.4132 18.8216 21.7396C18.4952 22.066 18.332 22.4583 18.332 22.9167C18.332 23.375 18.4952 23.7674 18.8216 24.0938C19.148 24.4201 19.5404 24.5833 19.9987 24.5833ZM17.4987 17.0833H22.4987V15.4167C22.4987 14.7222 22.2556 14.1319 21.7695 13.6458C21.2834 13.1597 20.6931 12.9167 19.9987 12.9167C19.3043 12.9167 18.714 13.1597 18.2279 13.6458C17.7418 14.1319 17.4987 14.7222 17.4987 15.4167V17.0833ZM14.9987 27.0833V18.75V27.0833Z",
    fill: "#004AC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLock);
export default __webpack_public_path__ + "static/media/ic-lock.a1198bbe8695e93bba7889d3b2f5b218.svg";
export { ForwardRef as ReactComponent };